import React, {
  useCallback, useEffect, useMemo, useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useField } from 'formik';

import { FormAutoComplete } from '../../../../components/index';
import { selectUserPermissionsList } from '../../../../store/modules/user-permissions/selectors';
import { getUserPermissionsListRequest } from '../../../../store/modules/user-permissions/actions';
import { uniqueList } from './utils';
import { Project } from '../../../../types/items';
import { ListParams } from '../../../../types/main';
import { selectCurrentUser } from '../../../../store/modules/users/selectors';

type Props = {
  // disabled?: boolean;
  project: Project | null;
  duplicate?: boolean;
};

const OwnerUserField = ({ project, duplicate = false }: Props) => {
  const dispatch = useDispatch();
  const { data: user } = useSelector(selectCurrentUser);
  const [organizationField] = useField('organization_id');
  const [organizationId, setOrganizationId] = useState(organizationField.value);
  const users = useSelector(selectUserPermissionsList);
  const canEdit = project?.permissions.can_edit || false;
  // const isAdmin = useSelector(selectIsAdmin);
  const params: ListParams = {
    sort_key: 'ref.full_name_first_last',
    page_size: 100,
  };

  if (parseInt(organizationField.value, 10) !== -1) {
    params.filter = {
      organization_id: (organizationField.value),
    };
  }

  const projectOwner = useMemo(() => ((project && project.ref)
    ? [{ id: project.ref.user_owner.id, label: project.ref.user_owner.full_name_first_last }]
    : []), [project]);

  const usersList = useMemo(() => {
    let list = (duplicate || canEdit)
      ? uniqueList(
        users.data?.items.filter((item) => item.ref.user !== null).map((item) => ({
          label: (parseInt(organizationField.value, 10) === -1)
            ? `${item.ref.user.full_name_first_last} (Id: ${item.ref.user.id})`
            : item.ref.user.full_name_first_last,
          id: item.ref.user.id,
        })),
      )
      : projectOwner;
    list.sort((a) => a.id === projectOwner[0].id ? -1 : 1);
    const currentUser = user ? [{ id: user.id, label: user.ref.full_name_first_last }] : projectOwner;
    if (Number(organizationField.value) === -1) {
      list = currentUser;
    }

    return list;
  }, [projectOwner, canEdit, users, organizationField, user, duplicate]);

  useEffect(() => {
    if (canEdit || duplicate) {
      dispatch(getUserPermissionsListRequest(params));
    }
    // eslint-disable-next-line
  }, [dispatch, canEdit, duplicate]);

  useEffect(() => {
    if (Number(organizationField.value) === -1) {
      return;
    }

    if (organizationId !== organizationField.value) {
      setOrganizationId(organizationField.value);
      dispatch(getUserPermissionsListRequest(params));
    }
  }, [dispatch, organizationField, organizationId, setOrganizationId, users, params]);

  // if (Number(organizationField.value) === -1 && !isAdmin && duplicate) {

  const onSearchCallback = useCallback((search: string) => {
    const searchParams: ListParams = {
      sort_key: 'ref.full_name_first_last',
      page_size: 100,
      filter: {
        search,
      },
    };
    dispatch(getUserPermissionsListRequest(searchParams));
  }, [dispatch]);

  // const organizationNotSelected = parseInt(organizationField.value, 10) === -1 && !isAdmin;
  const organizationNotSelected = parseInt(organizationField.value, 10) === -1;

  return (
    <FormAutoComplete
      disabled={organizationNotSelected || !canEdit}
      data={usersList}
      label="Owner"
      name="user_owner_id"
      disableClearable
      onSearch={parseInt(organizationField.value, 10) !== -1 ? () => {} : onSearchCallback}
    />
  );
};


export default OwnerUserField;
